import * as React from "react";
import { Link } from "./link";

type Props = {
  href: string;
  text: string;
};

export const ButtonLink: React.FC<Props> = (props) => {
  return (
    <div className="c-link-button">
      <Link href={props.href}>
        <span>{props.text}</span>
      </Link>
    </div>
  );
};
